<script setup>
import { useAnchorTitle } from '~/composables/useAnchorTitle'

const props = defineProps({
  title: {
    type: String,
  },
  slides: {
    type: Object,
  },
})

const anchorTitle = computed(() => useAnchorTitle(props.title))
</script>

<template>
  <div class="row slider-testimonials">
    <div class="col-12">
      <h2
        v-if="title"
        :id="anchorTitle"
        class="scale-5 scale-5--bold-uppercase slider-testimonials__title"
      >
        {{ title }}
      </h2>
      <div class="slider-testimonials__slider">
        <Slider
          :show-pagination="true"
          :wrap-around="true"
          :slides="slides"
          class="slider--overflow slider--fade-out"
        >
          <template #default="slide">
            <SlideTestimonial
              :slide="slide"
              :size="slide?.size"
            />
          </template>
        </Slider>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/node_modules/bootstrap/scss/mixins';

.slider-testimonials {
  &__title {
    margin-bottom: 30px;
  }

  &__slider {
    :deep(.carousel__track) {
      min-height: 600px;
    }

    :deep(.slider__slide) {
      padding-right: 15px !important;
      padding-left: 15px !important;
    }
  }
  :deep(.embla__slide) {
    flex: 0 0 83.333%; /* Default slide covers 100% of the viewport */
  }
  @media (min-width: 560px) {
    :deep(.embla__slide) {
      flex: 0 0 66.666%; /* Breakpoint SM slide covers 50% of the viewport */
    }
  }
  @media (min-width: 800px) {
    :deep(.embla__slide) {
      flex: 0 0 45.4545%; /* Breakpoint SM slide covers 50% of the viewport */
    }
  }

  @media (min-width: 1200px) {
    :deep(.embla__slide) {
      flex: 0 0 40%; /* Breakpoint SM slide covers 50% of the viewport */
    }
  }
}
</style>
